import axios from "axios"

const url =  "/serialnumber/api/v1/product/category/list";

export function getProductCategoryListing({
  length,
  start,
  column,
  order,
  search,
  status
}){
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: {
        length,
        start,
        column,
        order,
        search,
        status
      }
    })
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}